import { EntityState } from '@examdojo/state';
import { TableInsertModel, TableRowModel, TableUpdateModel } from '@examdojo/supabase';

export type ChallengeActivityHttpModel = Pick<
  TableRowModel<'challenge_activities', 'learning'>,
  'assignment_section_id' | 'created_at' | 'id' | 'status' | 'updated_at' | 'user_id'
>;
export type ChallengeActivityStoreModel = ChallengeActivityHttpModel;
export type ChallengeActivityUIModel = ChallengeActivityStoreModel;

export const CHALLENGE_ACTIVITY_CREATE_ALLOWED_KEYS = ['status', 'assignment_section_id', 'user_id'] satisfies Array<
  keyof TableInsertModel<'challenge_activities', 'learning'>
>;

export type ChallengeActivityCreateModel = Pick<
  TableInsertModel<'challenge_activities', 'learning'>,
  (typeof CHALLENGE_ACTIVITY_CREATE_ALLOWED_KEYS)[number]
>;

export const CHALLENGE_ACTIVITY_UPDATE_ALLOWED_KEYS = [...CHALLENGE_ACTIVITY_CREATE_ALLOWED_KEYS] satisfies Array<
  keyof TableUpdateModel<'challenge_activities', 'learning'>
>;

export type ChallengeActivityUpdateModel = Pick<
  TableUpdateModel<'challenge_activities', 'learning'>,
  (typeof CHALLENGE_ACTIVITY_UPDATE_ALLOWED_KEYS)[number]
>;

export interface ChallengeActivityState extends EntityState<ChallengeActivityStoreModel> {}

export type ChallengeActivityStatus = ChallengeActivityHttpModel['status'];
